import { atom } from "jotai";
import { FinancialProductReadDTO } from "../types/FinancialApplication";
import FinancialApplicationApiClient from "../api/financialApplicationApiClient";

// Create a regular atom to store the financial products
export const financialProductsAtom = atom<FinancialProductReadDTO[]>([]);

// Create a loading state atom
export const financialProductsLoadingAtom = atom<boolean>(false);

// Create an error state atom
export const financialProductsErrorAtom = atom<string | null>(null);

// Create a flag to track if we've already fetched products (to prevent duplicate requests)
export const financialProductsFetchedAtom = atom<boolean>(false);

// Create a derived atom that provides the refresh function
export const financialProductsRefreshAtom = atom(
  null,
  async (get, set, apiClient: FinancialApplicationApiClient, forceRefresh: boolean = false) => {
    // Check if we're already loading or if we've already fetched (unless forcing refresh)
    if (get(financialProductsLoadingAtom) || (!forceRefresh && get(financialProductsFetchedAtom))) {
      return;
    }
    
    set(financialProductsLoadingAtom, true);
    set(financialProductsErrorAtom, null);
    
    try {
      const response = await apiClient.getFinancialProducts();
      set(financialProductsAtom, response);
      set(financialProductsFetchedAtom, true);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to fetch financial products";
      set(financialProductsErrorAtom, errorMessage);
      set(financialProductsAtom, []);
    } finally {
      set(financialProductsLoadingAtom, false);
    }
  }
);
